import { render } from "./ReceiversView.vue?vue&type=template&id=b1e5339e"
import script from "./ReceiversView.vue?vue&type=script&lang=js"
export * from "./ReceiversView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__